import { render, staticRenderFns } from "./DeviceExtendParamsConfig.vue?vue&type=template&id=3ae982fb&scoped=true"
import script from "./DeviceExtendParamsConfig.vue?vue&type=script&lang=js"
export * from "./DeviceExtendParamsConfig.vue?vue&type=script&lang=js"
import style0 from "./DeviceExtendParamsConfig.vue?vue&type=style&index=0&id=3ae982fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae982fb",
  null
  
)

export default component.exports